// Session Events
export enum SessionCopiedFormat {
  PLAIN_TEXT = 'plain_text',
  FORMAT_WITHOUT_LISTS = 'format_without_lists',
  FORMAT_WITH_LISTS = 'format_with_lists',
  // Emitted whenever the four-toggle path runs (FF
  // `release-scribe-improve-copy-actions` on). Lets dashboards split
  // toggle adoption from the legacy enum buckets.
  WITH_TOGGLES = 'with_toggles',
}

export enum CopyMethod {
  CLICK = 'click',
  SHORTCUT = 'shortcut',
}

/**
 * Which copy affordance the user reached for. Enumerated from the emit sites
 * rather than from the UI chrome, so a button that moves between layouts keeps
 * its label:
 *
 * - `rhs_copy_button` — whole-note Copy, wherever it is mounted (V1 kebab menu,
 *   V1 toolbar, V1 mobile bar, V2 footer, V2 note-context card).
 * - `pane_copy_button` — the selection bubble/text-menu Copy command, which is
 *   the only in-editor path that honours the formatting toggles.
 * - `editor_clipboard` — verbatim clipboard copies (⌘C, cut, native
 *   context-menu) served by the editors' clipboard serializers.
 * - `template_editor` — copies inside a template editor (template builder,
 *   onboarding template surfaces): verbatim clipboard (⌘C / cut / context-menu)
 *   and the Copy button / dropdown. Distinguisher is `copy_method`.
 * - `action_center_panel` — the Action Center detail panel.
 * - `drag_handle` — the block drag-handle Copy with/without formatting
 *   commands, which write a verbatim node (no copy-settings).
 * - `fullscript_handoff` — copy initiated by the Fullscript handoff.
 */
export type SessionCopySource =
  | 'rhs_copy_button'
  | 'pane_copy_button'
  | 'editor_clipboard'
  | 'template_editor'
  | 'action_center_panel'
  | 'drag_handle'
  | 'fullscript_handoff';
